import axios from 'axios';

const LiveData = new function() {
  this.liveData = false;

  //Live data for parkingspaces
  this.getLiveData = function() {
    //Set livedata to true to avoid multiple instanciations while awaiting response from server
    this.liveData = true;
    return new Promise((resolve) => {
      axios.get('https://apps.odenserundt.dk/data/parkering/live.json')
      .then(response => {
        console.log(response);
        this.liveData = response.data;
        resolve();
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        resolve();
      });
    });
  };

  this.findParkingColor = function(feature) {
  	var iconColor = '';

  	if(feature.properties.prop78) {
  		var data = this.liveData[feature.properties.prop78.value];
  		if(data && data != '') {
  			if(data.freeCount === "" || data.maxCount == 0) {
  				//Blue
  				iconColor = 'rgb(000, 150, 206)';
  			}
  			else if(data.freeCount <= 5) {
  				//Pink
  				iconColor = 'rgb(245, 085, 120)';
  			}
  			else if(data.freeCount >5 && data.freeCount <=20) {
  				//Yellow
  				iconColor = 'rgb(255, 208, 62)';
  			}
  			else if(data.freeCount >= 20) {
  				//Dark green
  				iconColor =  'rgb(000, 145, 73)';
  			}
  		}
  		else {
  			iconColor = 'rgb(000, 150, 206)';
  		}
  	}
  	else {
  		//Blue
  		iconColor = 'rgb(000, 150, 206)';
  	}
  	return iconColor;
  };

  this.findParkingText = function(feature) {
  	var iconText = '';
  	if(feature.properties.prop78) {
  		var data = this.liveData[feature.properties.prop78.value];
  		if(data && data != '') {
  			if(data.freeCount === "") {
  				iconText = 'P';
  			}
  			else if(data.freeCount <= 2) {
  				if(data.freeCount == 0 && data.maxCount == 0) {
  					iconText = 'P';
  				}
  				else {
  					iconText = '0-2';
  				}
  			}
  			else if(data.freeCount > 2 && data.freeCount <=9) {
  				iconText = '3+';
  			}
  			else if(data.freeCount >= 10) {
  				iconText = '10+';
  			}
  		}
      else {
        iconText = 'P';
      }
  	}
  	else {
  		if(feature.properties.prop52) {
  			if(feature.properties.prop52.option_id == 63) {
  				iconText = 'MC';
  			}
  			else {
  				iconText = 'P';
  			}
  		}
  		else {
  			iconText = 'P';
  		}
  	}
  	return '<span class="marker-text">'+iconText+'</span>';
  };
};

export default LiveData;
